import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ENTRYPOINT } from '@core/endpoint';
import { Pagination } from '@core/interface';

const MONITORING_URL = `${ENTRYPOINT}monitoringdata/`;

export interface Classificator {
  id: number;
  value: string;
  style: Record<string, any>;
}

export interface GeoDataSessionList {
  id: number;
  session_start: Date;
  partial_scan: boolean;
  scheduled_scan: boolean;
}

export interface GeoDataDetail extends GeoDataSessionList {
  session_end?: Date;
  greenhouse_id?: string;
  length_azimuth?: string;
  width_azimuth?: string;
  status_results?: Results;
  ndvi_results?: NdviResults;
  thermal_results?: ThermalResults;
  has_object_data?: boolean;
  ndvi_fgb_file?: string;
  thermal_fgb_file?: string;
}

interface Results {
  status_counts: Record<string, number>;
  tree_spiece_counts: Record<string, number>;
}
interface NdviResults {
  average_ndvi?: number;
}
interface ThermalResults {
  max_t?: number;
  min_t?: number;
  max_dt?: number;
  min_dt?: number;
}

@Injectable({ providedIn: 'root' })
export class MonitoringService {
  private readonly http = inject(HttpClient);

  loadSessions(): Observable<Pagination<GeoDataSessionList>> {
    return this.http.get<Pagination<GeoDataSessionList>>(
      `${MONITORING_URL}session/`,
    );
  }

  loadSession(id: number): Observable<GeoDataDetail> {
    return this.http.get<GeoDataDetail>(`${MONITORING_URL}session/${id}/`);
  }

  loadTreeSpecies(): Observable<Classificator[]> {
    return this.http.get<Classificator[]>(`${MONITORING_URL}treespecies/`);
  }

  loadCellStatus(): Observable<Classificator[]> {
    return this.http.get<Classificator[]>(`${MONITORING_URL}cellstatus/`);
  }
}
